
import {useFormikContext} from "formik";
import {AufgabeFormValues} from "../../types/aufgabenTypes";
import {DEFAULT_FOREIGN_LANGUAGE, DEFAULT_LANGUAGE} from "../../config/language";
import {useEffect, useState} from "react";
import {PromptTemplate} from "../../api";
import {useAufgabePromptTemplate} from "../../client/queries";

export default function TemplateHandling(){
    const {setFieldValue, values} = useFormikContext<AufgabeFormValues>();
    const defaultLang = DEFAULT_LANGUAGE.split("-")[0];
    const defaultForeignLang = DEFAULT_FOREIGN_LANGUAGE.split("-")[0];
    const [foreignLanguage, setForeignLanguage] = useState<string>(defaultForeignLang);
    const currentForeignPromptTemplate: PromptTemplate = useAufgabePromptTemplate(foreignLanguage);
    useEffect(() => {
        if(values.sprache && values.sprache.length === 5){
            const langCode = values.sprache.split("-")[0];
            setForeignLanguage(langCode);
            if(langCode !== defaultLang){
                setFieldValue("foreignPrompt", currentForeignPromptTemplate.template ?? "");
            } else {
                setFieldValue("foreignPrompt", "");
            }
        }
    }, [values.sprache, currentForeignPromptTemplate.template, setFieldValue, defaultLang]);
    return null;
}